import { type EditorPlugin } from '../../types/aha-editor';

const LinkCardSchemaPlugin: EditorPlugin = {
  name: 'LinkCard schema plugin',
  schema: {
    linkCard: {
      isInline: true,
      isVoid: true,
    },
  },
};

export default LinkCardSchemaPlugin;
